// extracted by mini-css-extract-plugin
export default {"addressAction":"T8-z","loading":"U8-z"};